import forearm_map from "./fixture_images/forearm_map.png";
import right_forearm_flexed from "./fixture_images/right_forearm_flexed.png";
import right_forearm_extended from "./fixture_images/right_forearm_extended.png";
import left_forearm_flexed from "./fixture_images/left_forearm_flexed.png";
import left_forearm_extended from "./fixture_images/left_forearm_extended.png";

import BMODE_4553 from "./fixture_images/study_fixture_sample_images/BMODE_4553e742-aa34-4042-ad0f-999ced82dcfe.jpg";
import BMODE_a2e4 from "./fixture_images/study_fixture_sample_images/BMODE_a2e4b387-de76-404d-853d-bf2fed557406.jpg";
import BMODE_b3fb from "./fixture_images/study_fixture_sample_images/BMODE_b3fb6fd0-6200-4eec-8550-dd32e502e563.jpg";
import BMODE_f6c8 from "./fixture_images/study_fixture_sample_images/BMODE_f6c8862b-b0cf-4597-b40a-038c353b1d4d.jpg";

import STL_sws_4a69 from "./fixture_images/study_fixture_sample_images/STL_sws_4a69df9b-52fd-467e-98fa-743ce0d23722.jpg";
import STL_velocity_4a69 from "./fixture_images/study_fixture_sample_images/STL_velocity_4a69df9b-52fd-467e-98fa-743ce0d23722.jpg";

import STL_sws_5a23 from "./fixture_images/study_fixture_sample_images/STL_sws_5a237f97-2570-4a78-a272-d0c0c5e9a63b.jpg";
import STL_velocity_5a23 from "./fixture_images/study_fixture_sample_images/STL_velocity_5a237f97-2570-4a78-a272-d0c0c5e9a63b.jpg";

import STL_sws_21f7 from "./fixture_images/study_fixture_sample_images/STL_sws_21f76528-d5b7-4f78-920d-1c8bc08496fc.jpg";
import STL_velocity_21f7 from "./fixture_images/study_fixture_sample_images/STL_velocity_21f76528-d5b7-4f78-920d-1c8bc08496fc.jpg";

import STL_sws_16d3 from "./fixture_images/study_fixture_sample_images/STL_sws_16d36aed-047c-4615-a961-bd1d4c4be084.jpg";
import STL_velocity_16d3 from "./fixture_images/study_fixture_sample_images/STL_velocity_16d36aed-047c-4615-a961-bd1d4c4be084.jpg";

import STL_sws_246e from "./fixture_images/study_fixture_sample_images/STL_sws_246ee860-6061-4f90-a325-5a05259dc8fb.jpg";
import STL_velocity_246e from "./fixture_images/study_fixture_sample_images/STL_velocity_246ee860-6061-4f90-a325-5a05259dc8fb.jpg";

import STL_sws_0738 from "./fixture_images/study_fixture_sample_images/STL_sws_0738daee-5de4-4ae0-99cf-fd5f2a57a3d5.jpg";
import STL_velocity_0738 from "./fixture_images/study_fixture_sample_images/STL_velocity_0738daee-5de4-4ae0-99cf-fd5f2a57a3d5.jpg";

import STL_sws_0854 from "./fixture_images/study_fixture_sample_images/STL_sws_0854aaac-c983-4165-83c2-e081e4916b9b.jpg";
import STL_velocity_0854 from "./fixture_images/study_fixture_sample_images/STL_velocity_0854aaac-c983-4165-83c2-e081e4916b9b.jpg";

import STL_sws_921f from "./fixture_images/study_fixture_sample_images/STL_sws_921f68ba-610a-4306-8771-7eccb231eb1a.jpg";
import STL_velocity_921f from "./fixture_images/study_fixture_sample_images/STL_velocity_921f68ba-610a-4306-8771-7eccb231eb1a.jpg";

import STL_sws_8979 from "./fixture_images/study_fixture_sample_images/STL_sws_8979e017-e9d8-4a4f-a04c-6f28e42ec9fa.jpg";
import STL_velocity_8979 from "./fixture_images/study_fixture_sample_images/STL_velocity_8979e017-e9d8-4a4f-a04c-6f28e42ec9fa.jpg";

import STL_sws_b971 from "./fixture_images/study_fixture_sample_images/STL_sws_b97102db-5d3b-419f-82e3-559de4ccda54.jpg";
import STL_velocity_b971 from "./fixture_images/study_fixture_sample_images/STL_velocity_b97102db-5d3b-419f-82e3-559de4ccda54.jpg";

import STL_sws_d8c5 from "./fixture_images/study_fixture_sample_images/STL_sws_d8c5641a-2026-4a3e-b660-ddeb06af6113.jpg";
import STL_velocity_d8c5 from "./fixture_images/study_fixture_sample_images/STL_velocity_d8c5641a-2026-4a3e-b660-ddeb06af6113.jpg";

import STL_sws_e1b2 from "./fixture_images/study_fixture_sample_images/STL_sws_e1b2b1f5-08d9-4ea1-ba30-29b41678d271.jpg";
import STL_velocity_e1b2 from "./fixture_images/study_fixture_sample_images/STL_velocity_e1b2b1f5-08d9-4ea1-ba30-29b41678d271.jpg";

export const studyFixture = {
  study: {
    studyInfo: {
      id: "2021_05_21_16_07_03_1621627623366",
      protocolId: "TRAINING_PROTOCOL",
      participantId: "NO_ID",
      protocolName: "Training Protocol",
      progress: 100,
      skinType: "",
      gender: "",
      otherId: "",
      birthYear: "",
      startedAt: "2021-05-21 16:07:03",
      studyDate: "05/21/2021",
      totalSamplesNeeded: 16,
      version: "2.4",
      encryption: false,
      locked: false,
      notes: null,
      study_filepath:
        "C:/Users/microelastic_user/Desktop/MicroElastic/demo_study.study",
      study_info_filepath:
        "C:/Users/microelastic_user/Desktop/MicroElastic/demo_study.study",
      multiple_study_files: [],
      studyHash: [
        { "5620849494dd49b355f6c18f2500297b": "2021-05-21 16:11:18" },
      ],
      studySaved: true,
      studySavePath:
        "C:/Users/microelastic_user/Desktop/MicroElastic/demo_study.study",
      username: "Demo User",
    },
    locations: {
      byId: {
        INNER_FOREARM_FLEXED_RIGHT: {
          id: "INNER_FOREARM_FLEXED_RIGHT",
          name: "Inner Forearm Flexed (R)",
          samplesNeeded: { BMODE: 1, CSI: 3 },
          samplesAcquired: { BMODE: 1, CSI: 3 },
          samplesProcessed: { BMODE: 1, CSI: 3 },
          samplesExcluded: { BMODE: 0, CSI: 0 },
          completed: true,
          alert: { status: false, sampleIncludedInStudy: false },
          shearWaveSpeed: {
            value: 3.253626666666667,
            standardDev: 0.06605663041831773,
          },
          thickness: { value: 1.9, standardDev: 0 },
          roiReference: {
            locationWide: { id: null, type: null },
            default: "a2e4b387-de76-404d-853d-bf2fed557406",
          },
          samples: [
            "a2e4b387-de76-404d-853d-bf2fed557406",
            "8979e017-e9d8-4a4f-a04c-6f28e42ec9fa",
            "921f68ba-610a-4306-8771-7eccb231eb1a",
            "21f76528-d5b7-4f78-920d-1c8bc08496fc",
          ],
        },
        INNER_FOREARM_EXTENDED_RIGHT: {
          id: "INNER_FOREARM_EXTENDED_RIGHT",
          name: "Inner Forearm Extended (R)",
          samplesNeeded: { BMODE: 1, CSI: 3 },
          samplesAcquired: { BMODE: 1, CSI: 3 },
          samplesProcessed: { BMODE: 1, CSI: 3 },
          samplesExcluded: { BMODE: 0, CSI: 0 },
          completed: true,
          alert: { status: false, sampleIncludedInStudy: false },
          shearWaveSpeed: {
            value: 3.2536366666666665,
            standardDev: 0.06615619917202688,
          },
          thickness: { value: 1.8, standardDev: 0 },
          roiReference: {
            locationWide: { id: null, type: null },
            default: "f6c8862b-b0cf-4597-b40a-038c353b1d4d",
          },
          samples: [
            "f6c8862b-b0cf-4597-b40a-038c353b1d4d",
            "b97102db-5d3b-419f-82e3-559de4ccda54",
            "e1b2b1f5-08d9-4ea1-ba30-29b41678d271",
            "0738daee-5de4-4ae0-99cf-fd5f2a57a3d5",
          ],
        },
        INNER_FOREARM_FLEXED_LEFT: {
          id: "INNER_FOREARM_FLEXED_LEFT",
          name: "Inner Forearm Flexed (L)",
          samplesNeeded: { BMODE: 1, CSI: 3 },
          samplesAcquired: { BMODE: 1, CSI: 3 },
          samplesProcessed: { BMODE: 1, CSI: 3 },
          samplesExcluded: { BMODE: 0, CSI: 0 },
          completed: true,
          alert: { status: false, sampleIncludedInStudy: false },
          shearWaveSpeed: { value: 3.21965, standardDev: 0.019600889435601187 },
          thickness: { value: 1.4, standardDev: 0 },
          roiReference: {
            locationWide: { id: null, type: null },
            default: "4553e742-aa34-4042-ad0f-999ced82dcfe",
          },
          samples: [
            "4553e742-aa34-4042-ad0f-999ced82dcfe",
            "4a69df9b-52fd-467e-98fa-743ce0d23722",
            "246ee860-6061-4f90-a325-5a05259dc8fb",
            "0854aaac-c983-4165-83c2-e081e4916b9b",
          ],
        },
        INNER_FOREARM_EXTENDED_LEFT: {
          id: "INNER_FOREARM_EXTENDED_LEFT",
          name: "Inner Forearm Extended (L)",
          samplesNeeded: { BMODE: 1, CSI: 3 },
          samplesAcquired: { BMODE: 1, CSI: 3 },
          samplesProcessed: { BMODE: 1, CSI: 3 },
          samplesExcluded: { BMODE: 0, CSI: 0 },
          completed: true,
          alert: { status: false, sampleIncludedInStudy: false },
          shearWaveSpeed: {
            value: 3.4011266666666664,
            standardDev: 0.0683108611829448,
          },
          thickness: { value: 1.3, standardDev: 0 },
          roiReference: {
            locationWide: { id: null, type: null },
            default: "b3fb6fd0-6200-4eec-8550-dd32e502e563",
          },
          samples: [
            "b3fb6fd0-6200-4eec-8550-dd32e502e563",
            "d8c5641a-2026-4a3e-b660-ddeb06af6113",
            "5a237f97-2570-4a78-a272-d0c0c5e9a63b",
            "16d36aed-047c-4615-a961-bd1d4c4be084",
          ],
        },
      },
      allIds: [
        "INNER_FOREARM_FLEXED_RIGHT",
        "INNER_FOREARM_EXTENDED_RIGHT",
        "INNER_FOREARM_FLEXED_LEFT",
        "INNER_FOREARM_EXTENDED_LEFT",
      ],
    },
    samples: {
      allIds: [
        "a2e4b387-de76-404d-853d-bf2fed557406",
        "8979e017-e9d8-4a4f-a04c-6f28e42ec9fa",
        "921f68ba-610a-4306-8771-7eccb231eb1a",
        "21f76528-d5b7-4f78-920d-1c8bc08496fc",
        "f6c8862b-b0cf-4597-b40a-038c353b1d4d",
        "b97102db-5d3b-419f-82e3-559de4ccda54",
        "e1b2b1f5-08d9-4ea1-ba30-29b41678d271",
        "0738daee-5de4-4ae0-99cf-fd5f2a57a3d5",
        "4553e742-aa34-4042-ad0f-999ced82dcfe",
        "4a69df9b-52fd-467e-98fa-743ce0d23722",
        "246ee860-6061-4f90-a325-5a05259dc8fb",
        "0854aaac-c983-4165-83c2-e081e4916b9b",
        "b3fb6fd0-6200-4eec-8550-dd32e502e563",
        "d8c5641a-2026-4a3e-b660-ddeb06af6113",
        "5a237f97-2570-4a78-a272-d0c0c5e9a63b",
        "16d36aed-047c-4615-a961-bd1d4c4be084",
      ],
      byId: {
        "a2e4b387-de76-404d-853d-bf2fed557406": {
          id: "a2e4b387-de76-404d-853d-bf2fed557406",
          type: "BMODE",
          processing: false,
          valueDisplay: true,
          selectable: true,
          dataAvailable: true,
          dataSaved: true,
          locationId: "INNER_FOREARM_FLEXED_RIGHT",
          alert: { state: false, type: [], message: null },
          error: { state: false, type: null },
          includeInStudy: true,
          notes: null,
          image: BMODE_a2e4,
          thickness: 1.9,
          xAxis: { range: [0, 4.51553], unit: "s", label: "T" },
          yAxis: { range: [6.4, 11.4, 130], unit: "mm", label: "Depth" },
          colorBar: { range: [-30, 0], unit: "dB", label: "Amplitude" },
          autoDetectedTopSurface: 7.37666,
          autoDetectedBottomSurface: 9.27672,
          topSurface: 7.37666,
          bottomSurface: 9.27672,
          zValue: 8.32669,
          calib: 7.4,
          setToAutoDetectedThickness: true,
        },
        "8979e017-e9d8-4a4f-a04c-6f28e42ec9fa": {
          id: "8979e017-e9d8-4a4f-a04c-6f28e42ec9fa",
          type: "STL",
          processing: false,
          valueDisplay: true,
          selectable: true,
          dataAvailable: true,
          dataSaved: true,
          locationId: "INNER_FOREARM_FLEXED_RIGHT",
          alert: { state: false, type: [], message: null },
          error: { state: false, type: null },
          includeInStudy: true,
          notes: null,
          roiDz: 0.95,
          percentSliceWidth: 50,
          dz: 1.9,
          swsPlot: {
            image: STL_sws_8979,
            xAxis: { range: [5, 7.5], unit: "mm", label: "rfoc" },
            yAxis: { range: [6.3, 11.3], unit: "mm", label: "Depth" },
            colorBar: {
              xAxis: { range: [-30, 0], unit: "dB", label: "Amplitude" },
              yAxis: { range: [0.9, 7.9], unit: "m/s", label: "SWS" },
            },
          },
          velocitySlicePlot: {
            image: STL_velocity_8979,
            peakData: [
              [5, 3.31256],
              [5.5, 3.31894],
              [6, 3.25655],
              [6.5, 3.25173],
              [7, 3.23367],
              [7.5, 3.30969],
            ],
            xAxis: { range: [5, 7.5], unit: "mm", label: "rfoc" },
            yAxis: { range: [0.9, 7.9], unit: "m/s", label: "SWS" },
            colorBar: { range: [-10, 10], unit: "m/s", label: "Velocity" },
          },
          zValue: 8.33,
          zList: { z0: 6.276, nz: 130, inc: 0.0385 },
          shearWaveSpeed: 3.28053,
          calib: 7.3,
        },
        "921f68ba-610a-4306-8771-7eccb231eb1a": {
          id: "921f68ba-610a-4306-8771-7eccb231eb1a",
          type: "STL",
          processing: false,
          valueDisplay: true,
          selectable: true,
          dataAvailable: true,
          dataSaved: true,
          locationId: "INNER_FOREARM_FLEXED_RIGHT",
          alert: { state: false, type: [], message: null },
          error: { state: false, type: null },
          includeInStudy: true,
          notes: null,
          roiDz: 0.95,
          percentSliceWidth: 50,
          dz: 1.9,
          swsPlot: {
            image: STL_sws_921f,
            xAxis: { range: [5, 7.5], unit: "mm", label: "rfoc" },
            yAxis: { range: [6.4, 11.4], unit: "mm", label: "Depth" },
            colorBar: {
              xAxis: { range: [-30, 0], unit: "dB", label: "Amplitude" },
              yAxis: { range: [0.9, 7.9], unit: "m/s", label: "SWS" },
            },
          },
          velocitySlicePlot: {
            image: STL_velocity_921f,
            peakData: [
              [5, 3.4003],
              [5.5, 3.33322],
              [6, 3.31163],
              [6.5, 3.28783],
              [7, 3.25736],
              [7.5, 3.31554],
            ],
            xAxis: { range: [5, 7.5], unit: "mm", label: "rfoc" },
            yAxis: { range: [0.9, 7.9], unit: "m/s", label: "SWS" },
            colorBar: { range: [-10, 10], unit: "m/s", label: "Velocity" },
          },
          zValue: 8.33,
          zList: { z0: 6.391, nz: 130, inc: 0.0385 },
          shearWaveSpeed: 3.31765,
          calib: 7.4,
        },
        "21f76528-d5b7-4f78-920d-1c8bc08496fc": {
          id: "21f76528-d5b7-4f78-920d-1c8bc08496fc",
          type: "STL",
          processing: false,
          valueDisplay: true,
          selectable: true,
          dataAvailable: true,
          dataSaved: true,
          locationId: "INNER_FOREARM_FLEXED_RIGHT",
          alert: { state: false, type: [], message: null },
          error: { state: false, type: null },
          includeInStudy: true,
          notes: null,
          roiDz: 0.95,
          percentSliceWidth: 50,
          dz: 1.9,
          swsPlot: {
            image: STL_sws_21f7,
            xAxis: { range: [5, 7.5], unit: "mm", label: "rfoc" },
            yAxis: { range: [6.4, 11.4], unit: "mm", label: "Depth" },
            colorBar: {
              xAxis: { range: [-30, 0], unit: "dB", label: "Amplitude" },
              yAxis: { range: [0.9, 7.9], unit: "m/s", label: "SWS" },
            },
          },
          velocitySlicePlot: {
            image: STL_velocity_21f7,
            peakData: [
              [5, 3.26054],
              [5.5, 3.18682],
              [6, 3.15433],
              [6.5, 3.09509],
              [7, 3.13189],
              [7.5, 3.14756],
            ],
            xAxis: { range: [5, 7.5], unit: "mm", label: "rfoc" },
            yAxis: { range: [0.9, 7.9], unit: "m/s", label: "SWS" },
            colorBar: { range: [-10, 10], unit: "m/s", label: "Velocity" },
          },
          zValue: 8.33,
          zList: { z0: 6.43, nz: 130, inc: 0.0385 },
          shearWaveSpeed: 3.1627,
          calib: 7.4,
        },
        "f6c8862b-b0cf-4597-b40a-038c353b1d4d": {
          id: "f6c8862b-b0cf-4597-b40a-038c353b1d4d",
          type: "BMODE",
          processing: false,
          valueDisplay: true,
          selectable: true,
          dataAvailable: true,
          dataSaved: true,
          locationId: "INNER_FOREARM_EXTENDED_RIGHT",
          alert: { state: false, type: [], message: null },
          error: { state: false, type: null },
          includeInStudy: true,
          notes: null,
          image: BMODE_f6c8,
          thickness: 1.8,
          xAxis: { range: [0, 4.81093], unit: "s", label: "T" },
          yAxis: { range: [6.4, 11.4, 130], unit: "mm", label: "Depth" },
          colorBar: { range: [-30, 0], unit: "dB", label: "Amplitude" },
          autoDetectedTopSurface: 7.4276,
          autoDetectedBottomSurface: 9.23073,
          topSurface: 7.4276,
          bottomSurface: 9.23073,
          zValue: 8.32916,
          calib: 7.4,
          setToAutoDetectedThickness: true,
        },
        "b97102db-5d3b-419f-82e3-559de4ccda54": {
          id: "b97102db-5d3b-419f-82e3-559de4ccda54",
          type: "STL",
          processing: false,
          valueDisplay: true,
          selectable: true,
          dataAvailable: true,
          dataSaved: true,
          locationId: "INNER_FOREARM_EXTENDED_RIGHT",
          alert: { state: false, type: [], message: null },
          error: { state: false, type: null },
          includeInStudy: true,
          notes: null,
          roiDz: 0.9,
          percentSliceWidth: 50,
          dz: 1.8,
          swsPlot: {
            image: STL_sws_b971,
            xAxis: { range: [5, 7.5], unit: "mm", label: "rfoc" },
            yAxis: { range: [6.4, 11.4], unit: "mm", label: "Depth" },
            colorBar: {
              xAxis: { range: [-30, 0], unit: "dB", label: "Amplitude" },
              yAxis: { range: [0.9, 7.9], unit: "m/s", label: "SWS" },
            },
          },
          velocitySlicePlot: {
            image: STL_velocity_b971,
            peakData: [
              [5, 3.39642],
              [5.5, 3.28457],
              [6, 3.25398],
              [6.5, 3.29232],
              [7, 3.22378],
              [7.5, 3.24235],
            ],
            xAxis: { range: [5, 7.5], unit: "mm", label: "rfoc" },
            yAxis: { range: [0.9, 7.9], unit: "m/s", label: "SWS" },
            colorBar: { range: [-10, 10], unit: "m/s", label: "Velocity" },
          },
          zValue: 8.33,
          zList: { z0: 6.391, nz: 130, inc: 0.0385 },
          shearWaveSpeed: 3.28224,
          calib: 7.4,
        },
        "e1b2b1f5-08d9-4ea1-ba30-29b41678d271": {
          id: "e1b2b1f5-08d9-4ea1-ba30-29b41678d271",
          type: "STL",
          processing: false,
          valueDisplay: true,
          selectable: true,
          dataAvailable: true,
          dataSaved: true,
          locationId: "INNER_FOREARM_EXTENDED_RIGHT",
          alert: { state: false, type: [], message: null },
          error: { state: false, type: null },
          includeInStudy: true,
          notes: null,
          roiDz: 0.9,
          percentSliceWidth: 50,
          dz: 1.8,
          swsPlot: {
            image: STL_sws_e1b2,
            xAxis: { range: [5, 7.5], unit: "mm", label: "rfoc" },
            yAxis: { range: [6.4, 11.4], unit: "mm", label: "Depth" },
            colorBar: {
              xAxis: { range: [-30, 0], unit: "dB", label: "Amplitude" },
              yAxis: { range: [0.9, 7.9], unit: "m/s", label: "SWS" },
            },
          },
          velocitySlicePlot: {
            image: STL_velocity_e1b2,
            peakData: [
              [5, 3.38194],
              [5.5, 3.37329],
              [6, 3.31416],
              [6.5, 3.26491],
              [7, 3.26767],
              [7.5, 3.29689],
            ],
            xAxis: { range: [5, 7.5], unit: "mm", label: "rfoc" },
            yAxis: { range: [0.9, 7.9], unit: "m/s", label: "SWS" },
            colorBar: { range: [-10, 10], unit: "m/s", label: "Velocity" },
          },
          zValue: 8.33,
          zList: { z0: 6.391, nz: 130, inc: 0.0385 },
          shearWaveSpeed: 3.31648,
          calib: 7.4,
        },
        "0738daee-5de4-4ae0-99cf-fd5f2a57a3d5": {
          id: "0738daee-5de4-4ae0-99cf-fd5f2a57a3d5",
          type: "STL",
          processing: false,
          valueDisplay: true,
          selectable: true,
          dataAvailable: true,
          dataSaved: true,
          locationId: "INNER_FOREARM_EXTENDED_RIGHT",
          alert: { state: false, type: [], message: null },
          error: { state: false, type: null },
          includeInStudy: true,
          notes: STL_sws_0738,
          roiDz: 0.9,
          percentSliceWidth: 50,
          dz: 1.8,
          swsPlot: {
            image: null,
            xAxis: { range: [5, 7.5], unit: "mm", label: "rfoc" },
            yAxis: { range: [6.4, 11.4], unit: "mm", label: "Depth" },
            colorBar: {
              xAxis: { range: [-30, 0], unit: "dB", label: "Amplitude" },
              yAxis: { range: [0.9, 7.9], unit: "m/s", label: "SWS" },
            },
          },
          velocitySlicePlot: {
            image: STL_velocity_0738,
            peakData: [
              [5, 3.21582],
              [5.5, 3.19374],
              [6, 3.16678],
              [6.5, 3.12996],
              [7, 3.14427],
              [7.5, 3.12257],
            ],
            xAxis: { range: [5, 7.5], unit: "mm", label: "rfoc" },
            yAxis: { range: [0.9, 7.9], unit: "m/s", label: "SWS" },
            colorBar: { range: [-10, 10], unit: "m/s", label: "Velocity" },
          },
          zValue: 8.33,
          zList: { z0: 6.43, nz: 130, inc: 0.0385 },
          shearWaveSpeed: 3.16219,
          calib: 7.4,
        },
        "4553e742-aa34-4042-ad0f-999ced82dcfe": {
          id: "4553e742-aa34-4042-ad0f-999ced82dcfe",
          type: "BMODE",
          processing: false,
          valueDisplay: true,
          selectable: true,
          dataAvailable: true,
          dataSaved: true,
          locationId: "INNER_FOREARM_FLEXED_LEFT",
          alert: { state: false, type: [], message: null },
          error: { state: false, type: null },
          includeInStudy: true,
          notes: null,
          image: BMODE_4553,
          thickness: 1.4,
          xAxis: { range: [0, 4.99026], unit: "s", label: "T" },
          yAxis: { range: [6.5, 11.5, 130], unit: "mm", label: "Depth" },
          colorBar: { range: [-30, 0], unit: "dB", label: "Amplitude" },
          autoDetectedTopSurface: 7.54941,
          autoDetectedBottomSurface: 8.94951,
          topSurface: 7.54941,
          bottomSurface: 8.94951,
          zValue: 8.24946,
          calib: 7.5,
          setToAutoDetectedThickness: true,
        },
        "4a69df9b-52fd-467e-98fa-743ce0d23722": {
          id: "4a69df9b-52fd-467e-98fa-743ce0d23722",
          type: "STL",
          processing: false,
          valueDisplay: true,
          selectable: true,
          dataAvailable: true,
          dataSaved: true,
          locationId: "INNER_FOREARM_FLEXED_LEFT",
          alert: { state: false, type: [], message: null },
          error: { state: false, type: null },
          includeInStudy: true,
          notes: null,
          roiDz: 0.7,
          percentSliceWidth: 50,
          dz: 1.4,
          swsPlot: {
            image: STL_sws_4a69,
            xAxis: { range: [5, 7.5], unit: "mm", label: "rfoc" },
            yAxis: { range: [6.4, 11.4], unit: "mm", label: "Depth" },
            colorBar: {
              xAxis: { range: [-30, 0], unit: "dB", label: "Amplitude" },
              yAxis: { range: [0.9, 7.9], unit: "m/s", label: "SWS" },
            },
          },
          velocitySlicePlot: {
            image: STL_velocity_4a69,
            peakData: [
              [5, 3.26706],
              [5.5, 3.21815],
              [6, 3.18696],
              [6.5, 3.17127],
              [7, 3.16972],
              [7.5, 3.20909],
            ],
            xAxis: { range: [5, 7.5], unit: "mm", label: "rfoc" },
            yAxis: { range: [0.9, 7.9], unit: "m/s", label: "SWS" },
            colorBar: { range: [-10, 10], unit: "m/s", label: "Velocity" },
          },
          zValue: 8.25,
          zList: { z0: 6.468, nz: 130, inc: 0.0385 },
          shearWaveSpeed: 3.20371,
          calib: 7.4,
        },
        "246ee860-6061-4f90-a325-5a05259dc8fb": {
          id: "246ee860-6061-4f90-a325-5a05259dc8fb",
          type: "STL",
          processing: false,
          valueDisplay: true,
          selectable: true,
          dataAvailable: true,
          dataSaved: true,
          locationId: "INNER_FOREARM_FLEXED_LEFT",
          alert: { state: false, type: [], message: null },
          error: { state: false, type: null },
          includeInStudy: true,
          notes: null,
          roiDz: 0.7,
          percentSliceWidth: 50,
          dz: 1.4,
          swsPlot: {
            image: STL_sws_246e,
            xAxis: { range: [5, 7.5], unit: "mm", label: "rfoc" },
            yAxis: { range: [6.5, 11.5], unit: "mm", label: "Depth" },
            colorBar: {
              xAxis: { range: [-30, 0], unit: "dB", label: "Amplitude" },
              yAxis: { range: [0.9, 7.9], unit: "m/s", label: "SWS" },
            },
          },
          velocitySlicePlot: {
            image: STL_velocity_246e,
            peakData: [
              [5, 3.27078],
              [5.5, 3.2168],
              [6, 3.20472],
              [6.5, 3.19315],
              [7, 3.15178],
              [7.5, 3.21065],
            ],
            xAxis: { range: [5, 7.5], unit: "mm", label: "rfoc" },
            yAxis: { range: [0.9, 7.9], unit: "m/s", label: "SWS" },
            colorBar: { range: [-10, 10], unit: "m/s", label: "Velocity" },
          },
          zValue: 8.25,
          zList: { z0: 6.506, nz: 130, inc: 0.0385 },
          shearWaveSpeed: 3.20798,
          calib: 7.5,
        },
        "0854aaac-c983-4165-83c2-e081e4916b9b": {
          id: "0854aaac-c983-4165-83c2-e081e4916b9b",
          type: "STL",
          processing: false,
          valueDisplay: true,
          selectable: true,
          dataAvailable: true,
          dataSaved: true,
          locationId: "INNER_FOREARM_FLEXED_LEFT",
          alert: { state: false, type: [], message: null },
          error: { state: false, type: null },
          includeInStudy: true,
          notes: null,
          roiDz: 0.7,
          percentSliceWidth: 50,
          dz: 1.4,
          swsPlot: {
            image: STL_sws_0854,
            xAxis: { range: [5, 7.5], unit: "mm", label: "rfoc" },
            yAxis: { range: [6.5, 11.5], unit: "mm", label: "Depth" },
            colorBar: {
              xAxis: { range: [-30, 0], unit: "dB", label: "Amplitude" },
              yAxis: { range: [0.9, 7.9], unit: "m/s", label: "SWS" },
            },
          },
          velocitySlicePlot: {
            image: STL_velocity_0854,
            peakData: [
              [5, 3.31292],
              [5.5, 3.27653],
              [6, 3.25],
              [6.5, 3.23519],
              [7, 3.19456],
              [7.5, 3.21435],
            ],
            xAxis: { range: [5, 7.5], unit: "mm", label: "rfoc" },
            yAxis: { range: [0.9, 7.9], unit: "m/s", label: "SWS" },
            colorBar: { range: [-10, 10], unit: "m/s", label: "Velocity" },
          },
          zValue: 8.25,
          zList: { z0: 6.545, nz: 130, inc: 0.0385 },
          shearWaveSpeed: 3.24726,
          calib: 7.5,
        },
        "b3fb6fd0-6200-4eec-8550-dd32e502e563": {
          id: "b3fb6fd0-6200-4eec-8550-dd32e502e563",
          type: "BMODE",
          processing: false,
          valueDisplay: true,
          selectable: true,
          dataAvailable: true,
          dataSaved: true,
          locationId: "INNER_FOREARM_EXTENDED_LEFT",
          alert: { state: false, type: [], message: null },
          error: { state: false, type: null },
          includeInStudy: true,
          notes: null,
          image: BMODE_b3fb,
          thickness: 1.3,
          xAxis: { range: [0, 4.98799], unit: "s", label: "T" },
          yAxis: { range: [6.5, 11.5, 130], unit: "mm", label: "Depth" },
          colorBar: { range: [-30, 0], unit: "dB", label: "Amplitude" },
          autoDetectedTopSurface: 7.58203,
          autoDetectedBottomSurface: 8.88223,
          topSurface: 7.58203,
          bottomSurface: 8.88223,
          zValue: 8.23213,
          calib: 7.5,
          setToAutoDetectedThickness: true,
        },
        "d8c5641a-2026-4a3e-b660-ddeb06af6113": {
          id: "d8c5641a-2026-4a3e-b660-ddeb06af6113",
          type: "STL",
          processing: false,
          valueDisplay: true,
          selectable: true,
          dataAvailable: true,
          dataSaved: true,
          locationId: "INNER_FOREARM_EXTENDED_LEFT",
          alert: { state: false, type: [], message: null },
          error: { state: false, type: null },
          includeInStudy: true,
          notes: null,
          roiDz: 0.65,
          percentSliceWidth: 50,
          dz: 1.3,
          swsPlot: {
            image: STL_sws_d8c5,
            xAxis: { range: [5, 7.5], unit: "mm", label: "rfoc" },
            yAxis: { range: [6.5, 11.5], unit: "mm", label: "Depth" },
            colorBar: {
              xAxis: { range: [-30, 0], unit: "dB", label: "Amplitude" },
              yAxis: { range: [0.9, 7.9], unit: "m/s", label: "SWS" },
            },
          },
          velocitySlicePlot: {
            image: STL_velocity_d8c5,
            peakData: [
              [5, 3.4257],
              [5.5, 3.37095],
              [6, 3.32381],
              [6.5, 3.30102],
              [7, 3.25662],
              [7.5, 3.29218],
            ],
            xAxis: { range: [5, 7.5], unit: "mm", label: "rfoc" },
            yAxis: { range: [0.9, 7.9], unit: "m/s", label: "SWS" },
            colorBar: { range: [-10, 10], unit: "m/s", label: "Velocity" },
          },
          zValue: 8.229999999999999,
          zList: { z0: 6.545, nz: 130, inc: 0.0385 },
          shearWaveSpeed: 3.32838,
          calib: 7.5,
        },
        "5a237f97-2570-4a78-a272-d0c0c5e9a63b": {
          id: "5a237f97-2570-4a78-a272-d0c0c5e9a63b",
          type: "STL",
          processing: false,
          valueDisplay: true,
          selectable: true,
          dataAvailable: true,
          dataSaved: true,
          locationId: "INNER_FOREARM_EXTENDED_LEFT",
          alert: { state: false, type: [], message: null },
          error: { state: false, type: null },
          includeInStudy: true,
          notes: null,
          roiDz: 0.65,
          percentSliceWidth: 50,
          dz: 1.3,
          swsPlot: {
            image: STL_sws_5a23,
            xAxis: { range: [5, 7.5], unit: "mm", label: "rfoc" },
            yAxis: { range: [6.5, 11.5], unit: "mm", label: "Depth" },
            colorBar: {
              xAxis: { range: [-30, 0], unit: "dB", label: "Amplitude" },
              yAxis: { range: [0.9, 7.9], unit: "m/s", label: "SWS" },
            },
          },
          velocitySlicePlot: {
            image: STL_velocity_5a23,
            peakData: [
              [5, 3.47973],
              [5.5, 3.38694],
              [6, 3.3623],
              [6.5, 3.36322],
              [7, 3.34404],
              [7.5, 3.35846],
            ],
            xAxis: { range: [5, 7.5], unit: "mm", label: "rfoc" },
            yAxis: { range: [0.9, 7.9], unit: "m/s", label: "SWS" },
            colorBar: { range: [-10, 10], unit: "m/s", label: "Velocity" },
          },
          zValue: 8.229999999999999,
          zList: { z0: 6.506, nz: 130, inc: 0.0385 },
          shearWaveSpeed: 3.38245,
          calib: 7.5,
        },
        "16d36aed-047c-4615-a961-bd1d4c4be084": {
          id: "16d36aed-047c-4615-a961-bd1d4c4be084",
          type: "STL",
          processing: false,
          valueDisplay: true,
          selectable: true,
          dataAvailable: true,
          dataSaved: true,
          locationId: "INNER_FOREARM_EXTENDED_LEFT",
          alert: { state: false, type: [], message: null },
          error: { state: false, type: null },
          includeInStudy: true,
          notes: null,
          roiDz: 0.65,
          percentSliceWidth: 50,
          dz: 1.3,
          swsPlot: {
            image: STL_sws_16d3,
            xAxis: { range: [5, 7.5], unit: "mm", label: "rfoc" },
            yAxis: { range: [6.5, 11.5], unit: "mm", label: "Depth" },
            colorBar: {
              xAxis: { range: [-30, 0], unit: "dB", label: "Amplitude" },
              yAxis: { range: [0.9, 7.9], unit: "m/s", label: "SWS" },
            },
          },
          velocitySlicePlot: {
            image: STL_velocity_16d3,
            peakData: [
              [5, 3.57581],
              [5.5, 3.47288],
              [6, 3.48497],
              [6.5, 3.49102],
              [7, 3.45994],
              [7.5, 3.4707],
            ],
            xAxis: { range: [5, 7.5], unit: "mm", label: "rfoc" },
            yAxis: { range: [0.9, 7.9], unit: "m/s", label: "SWS" },
            colorBar: { range: [-10, 10], unit: "m/s", label: "Velocity" },
          },
          zValue: 8.229999999999999,
          zList: { z0: 6.545, nz: 130, inc: 0.0385 },
          shearWaveSpeed: 3.49255,
          calib: 7.5,
        },
      },
      idByType: {
        BMODE: [
          "a2e4b387-de76-404d-853d-bf2fed557406",
          "f6c8862b-b0cf-4597-b40a-038c353b1d4d",
          "4553e742-aa34-4042-ad0f-999ced82dcfe",
          "b3fb6fd0-6200-4eec-8550-dd32e502e563",
        ],
        CSI: [
          "8979e017-e9d8-4a4f-a04c-6f28e42ec9fa",
          "921f68ba-610a-4306-8771-7eccb231eb1a",
          "21f76528-d5b7-4f78-920d-1c8bc08496fc",
          "b97102db-5d3b-419f-82e3-559de4ccda54",
          "e1b2b1f5-08d9-4ea1-ba30-29b41678d271",
          "0738daee-5de4-4ae0-99cf-fd5f2a57a3d5",
          "4a69df9b-52fd-467e-98fa-743ce0d23722",
          "246ee860-6061-4f90-a325-5a05259dc8fb",
          "0854aaac-c983-4165-83c2-e081e4916b9b",
          "d8c5641a-2026-4a3e-b660-ddeb06af6113",
          "5a237f97-2570-4a78-a272-d0c0c5e9a63b",
          "16d36aed-047c-4615-a961-bd1d4c4be084",
        ],
      },
    },
  },
  protocol: {
    protocolId: "TRAINING_PROTOCOL",
    protocolName: "Training Protocol",
    modified: false,
    locations: {
      INNER_FOREARM_FLEXED_RIGHT: {
        name: "Inner Forearm Flexed (R)",
        samples_needed: { BMODE: 1, CSI: 3 },
        notes: null,
        maps: {
          ForearmMap: [
            29.008196721311474, 35.01945525291829, 26.87704918032787,
            28.59922178988327, 23.598360655737704, 29.182879377431906,
            20.975409836065573, 29.766536964980546, 18.516393442622952,
            30.544747081712064, 19.172131147540984, 35.60311284046693,
            22.28688524590164, 35.60311284046693, 25.729508196721312,
            35.60311284046693,
          ],
        },
        instruction: {
          text: 'The participant should have their right arm flexed with their elbow bent. The target region is a horizontal band, 2-3" wide, located 1" below the elbow.',
          illustration: [
            {
              image: right_forearm_flexed,
              filename: "right_forearm_flexed.png",
            },
          ],
        },
        parameters_id: "STL",
      },
      INNER_FOREARM_EXTENDED_RIGHT: {
        name: "Inner Forearm Extended (R)",
        samples_needed: { BMODE: 1, CSI: 3 },
        notes: null,
        maps: {
          ForearmMap: [
            20.31967213114754, 81.90661478599222, 16.71311475409836,
            77.62645914396887, 14.254098360655737, 80.73929961089495,
            12.12295081967213, 83.26848249027238, 13.762295081967213,
            87.35408560311284, 17.204918032786885, 84.63035019455253,
          ],
        },
        instruction: {
          text: 'The participant should have their right arm fully extended. The target region is a horizontal band, 2-3" wide, located 1" below the elbow.',
          illustration: [
            {
              image: right_forearm_extended,
              filename: "right_forearm_extended.png",
            },
          ],
        },
        parameters_id: "STL",
      },
      INNER_FOREARM_FLEXED_LEFT: {
        name: "Inner Forearm Flexed (L)",
        samples_needed: { BMODE: 1, CSI: 3 },
        notes: null,
        maps: {
          ForearmMap: [
            70.49180327868852, 35.01945525291829, 72.62295081967213,
            28.59922178988327, 75.90163934426229, 29.182879377431906,
            78.52459016393442, 29.766536964980546, 80.98360655737704,
            30.544747081712064, 80.32786885245902, 35.60311284046693,
            77.21311475409836, 35.60311284046693, 73.77049180327869,
            35.60311284046693,
          ],
        },
        instruction: {
          text: 'The participant should have their left arm flexed with their elbow bent. The target region is a horizontal band, 2-3" wide, located 1" below the elbow.',
          illustration: [
            { image: left_forearm_flexed, filename: "left_forearm_flexed.png" },
          ],
        },
        parameters_id: "STL",
      },
      INNER_FOREARM_EXTENDED_LEFT: {
        name: "Inner Forearm Extended (L)",
        samples_needed: { BMODE: 1, CSI: 3 },
        notes: null,
        maps: {
          ForearmMap: [
            79.18032786885246, 81.90661478599222, 82.78688524590164,
            77.62645914396887, 85.24590163934427, 80.73929961089495,
            87.37704918032787, 83.26848249027238, 85.73770491803279,
            87.35408560311284, 82.29508196721312, 84.63035019455253,
          ],
        },
        instruction: {
          text: 'The participant should have their left arm fully extended. The target region is a horizontal band, 2-3" wide, located 1" below the elbow.',
          illustration: [
            {
              image: left_forearm_extended,
              filename: "left_forearm_extended.png",
            },
          ],
        },
        parameters_id: "STL",
      },
    },
    maps: {
      ForearmMap: {
        name: "Forearm Map",
        image: forearm_map,
        filename: "forearm_map.png",
      },
    },
    acq_types: { BMODE: { name: "T-Mode" }, CSI: { name: "E-Mode" } },
    parameters: { STL: { name: "STL" } },
  },
};
